import { getMessageFactory } from "../getCaxaWebSocket.js";
const closePageOpenSpecifiedPage = getMessageFactory({
  code: "CLOSE_AND_OPEN_URL"
});
export { closePageOpenSpecifiedPage };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/closePageOpenSpecifiedPages.js